export default {
    name: "FilterRadioButton",
    props: {
        label: {
            type: String,
            default: ""
        },
        name: {
            type: String,
            required: true
        },
        value: {
            type: String,
            required: true
        },
        checked: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        onChange() {
            const value = this.value;
            this.$emit("filter-radio-changed", value);
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/Synonym/SynonymFilter/FilterRadioButton/FilterRadioButton.js